export const hasDependentCoveragesSelector = (state) => {
    return state.policyData.billGroupData && Boolean(state.policyData.billGroupData.memberGroups.find(memberGroup => memberGroup.coverages.find(coverage => coverage.product.dependentProduct)));
};